import { ChangeDetectionStrategy, Component, Input, input, output } from '@angular/core';
import { NgClass } from '@angular/common';
import { ClickOutside } from '@shared/directives/click-outside';

@Component({
  selector: 'app-page-size-dropdown',
  imports: [
    NgClass,
    ClickOutside,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './page-size-dropdown.component.html',
  styleUrl: './page-size-dropdown.component.scss',
})
export class PageSizeDropdownComponent {
  showDropdown = false;
  pageSizeOptions = input.required<number[]>();
  @Input() selectedOption: number = 5;
  pageSizeChanged = output<number>();

  optionSelected(option: any) {
    this.selectedOption = option;
    this.pageSizeChanged.emit(option);
    this.closeDropdown();
  }

  toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
  }

  closeDropdown($event?: MouseEvent): void {
    // $event?.stopPropagation();
    this.showDropdown = false;
  }
}
